import { ApplicationValue } from '../../../services/warmup/application-type.model';
import { Type } from 'class-transformer';

/**
 * Model to save user preferences.
 *
 * @author pankaj.khurana@vernuso.com (Pankaj Khurana)
 */
export class UserPreferencesModel {
    id: number;
    displayName: string;
    email: string;
    exchangeEwsUrl: string;
    popEmailId: string;
    popHost: string;
    popPort: number;
    imapEmailId: string;
    imapHost: string;
    imapPort: number;
    @Type(() => ApplicationValue)
    connectionMode: ApplicationValue;
    @Type(() => ApplicationValue)
    language: ApplicationValue;
}



// WEBPACK FOOTER //
// ./src/app/header/usersettings/userpreferences/user-preferences.model.ts